import React, { useState } from 'react';
import propTypes from 'prop-types';
import Modal from 'tailwind-components/Modal/Modal';
import SBERequestNotice from './SBERequestNotice';
import SBEInstructions from './SBEInstructions';

// single SBE modal that toggles internally between the cert notice and the
// per-state instructions, instead of two parent-controlled modals
export default function SBEModal({
  requestedStates,
  closeModal,
  handleSubmit,
  isLoading
}) {
  const [areInstructionsOpen, setAreInstructionsOpen] = useState(false);

  return (
    <Modal
      active
      isLoading={isLoading}
      size={areInstructionsOpen ? 'larger' : 'large'}
      title={
        areInstructionsOpen
          ? 'State Based Exchange Request Instructions'
          : 'State Based Exchange Request'
      }
      closeModal={closeModal}
    >
      {areInstructionsOpen ? (
        <SBEInstructions
          requestedStates={requestedStates}
          closeModal={closeModal}
          handleSubmit={handleSubmit}
        />
      ) : (
        <SBERequestNotice
          requestedStates={requestedStates}
          closeModal={closeModal}
          setAreInstructionsOpen={setAreInstructionsOpen}
          handleSubmit={handleSubmit}
        />
      )}
    </Modal>
  );
}

SBEModal.propTypes = {
  requestedStates: propTypes.array.isRequired,
  closeModal: propTypes.func.isRequired,
  handleSubmit: propTypes.func.isRequired,
  isLoading: propTypes.bool
};
